export enum SaveSearchPermissionType {
  Open = 'OPEN',
  Private = 'PRIVATE',
  Shared = 'SHARED',
}
